/** WalletConnect 配对诊断：Console 输出 + URI 超时检测 */

const WC_URI_WAIT_MS = 30000;

export function attachWalletConnectDiagnostics(provider, label = "evm") {
  if (!provider || typeof provider.on !== "function") {
    return { wasUriReceived: () => false, dispose: () => {} };
  }

  let uriReceived = false;
  const push = (step, detail = "") => {
    console.info(`[WC:${label}] ${step}${detail ? ` — ${detail}` : ""}`);
  };

  push("provider ready", `connected=${!!provider.connected}`);

  const relayer = provider?.signer?.client?.core?.relayer;
  if (relayer) {
    push("relayer", `connected=${!!relayer.connected}`);
    relayer.on("connect", () => push("relayer connect"));
    relayer.on("disconnect", () => push("relayer disconnect"));
  } else {
    push("relayer missing");
  }

  const onUri = (uri) => {
    uriReceived = true;
    push("display_uri", `${String(uri || "").slice(0, 48)}…`);
    if (typeof window !== "undefined") {
      window.__hieswapWcLastUri = String(uri || "");
    }
  };
  provider.on("display_uri", onUri);

  return {
    wasUriReceived: () => uriReceived,
    dispose: () => {
      try {
        provider.removeListener("display_uri", onUri);
      } catch (_e) {
        void _e;
      }
    },
  };
}

export async function enableWithUriDiagnostics(provider, label = "evm") {
  const diag = attachWalletConnectDiagnostics(provider, label);
  const enablePromise = provider.enable();

  const timeoutGuard = new Promise((_, reject) => {
    const timer = setTimeout(() => {
      if (diag.wasUriReceived()) return;
      const relayUp = !!provider?.signer?.client?.core?.relayer?.connected;
      reject(new Error(relayUp ? "WC_URI_TIMEOUT" : "WC_RELAY_TIMEOUT"));
    }, WC_URI_WAIT_MS);
    enablePromise.finally(() => clearTimeout(timer));
  });

  try {
    return await Promise.race([enablePromise, timeoutGuard]);
  } finally {
    diag.dispose();
  }
}
